import React from 'react';

import { css } from '@emotion/core';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Divider as ADivider, DividerProps } from 'antd';
import { tuple } from 'antd/lib/_util/type';

export const tYzTypeDivider = tuple(
  'BLACK',
  'GREY',
  'GREY_DETAIL',
  'TRANSPARENT',
  'TRANSPARENT_LITTLE_SPACE',
);

type TYzTypeDivider = typeof tYzTypeDivider[number] | undefined;

type THandleCheckDividerTypeParams = {
  yzTypeDivider?: TYzTypeDivider;
};

export interface IDividerParams extends DividerProps {
  yzTypeDivider?: TYzTypeDivider;
  margin?: number;
}

const handleCheckDividerType = ({ yzTypeDivider }: THandleCheckDividerTypeParams) => {
  switch (yzTypeDivider) {
    case 'BLACK':
      return css`
        border-color: #8991a3 !important;
        background-color: #8991a3 !important;
        margin: 20px 0 20px 0 !important;
        width: 100%;
      `;
    case 'GREY':
      return css`
        border-color: #e5e5e5 !important;
        background-color: #ecf0f4 !important;
        margin: 15px 0 0 0;
      `;
    case 'GREY_DETAIL':
      return css`
        border-color: #d9dde1 !important;
        background-color: #d9dde1 !important;
        margin: 15px 0 15px 0;
      `;
    case 'TRANSPARENT':
      return css`
        border: 0;
        border-color: transparent !important;
        background-color: transparent !important;
        margin: 20px 0 20px 0;
      `;
    case 'TRANSPARENT_LITTLE_SPACE':
      return css`
        border: 0;
        border-color: transparent !important;
        background-color: transparent !important;
        margin: 10px 0 10px 0;
      `;
    default:
      return css``;
  }
};

const StyledDivider = styled(ADivider, { shouldForwardProp: isPropValid })<IDividerParams>`
  height: 1px;
  ${({ yzTypeDivider }) => handleCheckDividerType({ yzTypeDivider })}
  ${({ margin }) =>
    margin &&
    css`
      margin-top: ${margin}px !important;
      margin-bottom: ${margin}px !important;
    `}
`;

export const Divider = ({ ...rest }: IDividerParams) => <StyledDivider {...rest} />;
